import { onMounted, ref } from "vue"

export default {
    name: "FilterTabs",
    props: {
        initActiveTab: {
            type: String,
            required: true,
        },
        tabs: {
            type: Array,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        },
        canShowDropdown: {
            type: Boolean,
            required: false,
            default: true,
        },
        dropdownLabel: {
            type: String,
            required: false,
        }
        
    },
    setup(props) {
        const tabContainer = ref(null)
        const lineElement = ref(null)
        const activeTab = ref(props.initActiveTab)

        onMounted(() => {
            startTabMutationObserver()
            const indexOfActiveTab = props.tabs.findIndex((tab) => tab.id === props.initActiveTab)
            tabContainer.value.querySelectorAll("button")[indexOfActiveTab].setAttribute("aria-selected", true)
        })

        const drawTabActiveBorder = (activeElm) => {
            const tabContainerLeft = tabContainer.value.getBoundingClientRect().left

            const activeElmLeft = activeElm.getBoundingClientRect().left
            const lineLeftPos = activeElmLeft - tabContainerLeft + tabContainer.value.scrollLeft

            lineElement.value.style.left = `${lineLeftPos}px`
            lineElement.value.style.width = `${activeElm.clientWidth}px`
        }

        const handleTabChanges = function (mutationsList) {
            mutationsList.forEach((mutation) => {
                if (mutation.type === "attributes" && mutation.target.getAttribute("aria-selected") === "true") {
                    drawTabActiveBorder(mutation.target)
                }
            })
        }

        const startTabMutationObserver = () => {
            const config = { attributes: true, childList: true, subtree: true }

            const observer = new MutationObserver(handleTabChanges)
            observer.observe(tabContainer.value, config)
        }

        const changeTab = (tabId) => {
            activeTab.value = tabId
            if (props.callback) {
                props.callback(tabId)
            }
        }

        const handleKeyNavigation = (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' &&
                e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return

            e.preventDefault()
            const tabButtons = Array.from(tabContainer.value.querySelectorAll('[role="tab"]'))
            const tabButton = e.target.closest('[role="tab"]')
            if (!tabButton) return
            const currentIndex = tabButtons.findIndex(btn => btn === tabButton)
            if (currentIndex === -1) return

            let nextIndex
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                nextIndex = (currentIndex + 1) % tabButtons.length
            } else {
                nextIndex = (currentIndex - 1 + tabButtons.length) % tabButtons.length
            }

            tabButtons[nextIndex].focus()
            changeTab(props.tabs[nextIndex].id)
        }

        return {
            changeTab,
            handleKeyNavigation,
            tabContainer,
            lineElement,
            activeTab,
        }
    },
}
